__webpack_require__.p = "https://bmidxbswitzerlanddeplpreprod.netlify.app/";